import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../asstes/img/dl_071.png'
import _imports_1 from '../asstes/img/dl_07.png'
import _imports_2 from '../asstes/img/dl_06.png'
import _imports_3 from '../asstes/img/dl_09.png'
import _imports_4 from '../asstes/img/dl_13.png'
import _imports_5 from '../asstes/img/close.png'
import _imports_6 from '../asstes/img/erweimax.png'
import _imports_7 from '../asstes/img/win.png'
import _imports_8 from '../asstes/img/applex.png'
import _imports_9 from '../asstes/img/androidx.png'
import _imports_10 from '../asstes/img/weixin.png'
import _imports_11 from '../asstes/img/cuowu.jpg'


const _withScopeId = n => (_pushScopeId("data-v-aebd84a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "hbg" }
const _hoisted_3 = { class: "lg" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top cl" }, null, -1))
const _hoisted_5 = { class: "dlconx cl" }
const _hoisted_6 = { class: "dlcon cl" }
const _hoisted_7 = { class: "dlconl fl" }
const _hoisted_8 = { class: "sections" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "dot" }
const _hoisted_14 = { class: "dlconr fr" }
const _hoisted_15 = { class: "cl" }
const _hoisted_16 = { class: "cl li" }
const _hoisted_17 = { class: "cl" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_19 = { class: "cl li" }
const _hoisted_20 = { class: "cl" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1))
const _hoisted_22 = ["type"]
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "cl li" }
const _hoisted_25 = { class: "cl cl1" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1))
const _hoisted_27 = { class: "dd1" }
const _hoisted_28 = { class: "denglu cl" }
const _hoisted_29 = { class: "denglul fl" }
const _hoisted_30 = { class: "denglur fl" }
const _hoisted_31 = { class: "bot cl" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 版权所有：")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("   技术支持：")
const _hoisted_34 = {
  class: "black",
  href: "#",
  target: "_blank"
}
const _hoisted_35 = {
  href: "https://beian.miit.gov.cn/",
  target: "_blank",
  class: "black"
}
const _hoisted_36 = { class: "locon cl" }
const _hoisted_37 = { class: "lotit cl" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lotitl fl" }, "下载客户端", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<div class=\"loc cl\" data-v-aebd84a4><img src=\"" + _imports_6 + "\" data-v-aebd84a4><strong data-v-aebd84a4> 移动端扫码下载 </strong></div><div class=\"lob cl\" data-v-aebd84a4><a class=\"a1\" href=\"http://www.yuwangyun.com/client/pc.zip\" data-v-aebd84a4><img src=\"" + _imports_7 + "\" data-v-aebd84a4></a><a class=\"a2\" href=\"http://www.yuwangyun.com/client/ios.zip\" data-v-aebd84a4><img src=\"" + _imports_8 + "\" data-v-aebd84a4></a><a class=\"a3\" href=\"http://www.yuwangyun.com/client/android.apk\" data-v-aebd84a4><img src=\"" + _imports_9 + "\" data-v-aebd84a4></a><a class=\"a4\" href=\"sphone.html#/\" data-v-aebd84a4><img src=\"" + _imports_10 + "\" data-v-aebd84a4></a></div>", 2)
const _hoisted_43 = { class: "errxcon" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_11 })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SIdentify = _resolveComponent("SIdentify")!
  const _component_TanChuang = _resolveComponent("TanChuang")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", {
            href: "javascript:void(0);",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.xiazai && _ctx.xiazai(...args)))
          }, " 客户端下载 ")
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.zhuangtai.section1)
              }, _hoisted_10, 2),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.zhuangtai.section2)
              }, _hoisted_12, 2)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.zhuangtai.on1),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dot(0)))
              }, null, 2),
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.zhuangtai.on2),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dot(1)))
              }, null, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("ul", _hoisted_15, [
              _createElementVNode("li", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.dl && _ctx.dl(...args))),
                class: _normalizeClass(_ctx.zhuangtai.classa)
              }, "账户登录", 2)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.zhuangtai.con1)
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("dl", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("dd", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.username) = $event)),
                      placeholder: "请输入登录名"
                    }, null, 512), [
                      [_vModelText, _ctx.username]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("dl", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("dd", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: _ctx.password,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userpwd) = $event)),
                      placeholder: "请输入登录密码"
                    }, null, 8, _hoisted_22), [
                      [_vModelDynamic, _ctx.userpwd]
                    ]),
                    _createElementVNode("img", {
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.shownopwd && _ctx.shownopwd(...args))),
                      src: _ctx.eyeimg
                    }, null, 8, _hoisted_23)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("dl", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("dd", _hoisted_27, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.usercode) = $event)),
                      onKeydown: _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["enter"])),
                      placeholder: "请输入验证码"
                    }, null, 544), [
                      [_vModelText, _ctx.usercode]
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "yanzheng",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.refreshCode && _ctx.refreshCode(...args)))
                }, [
                  _createVNode(_component_SIdentify, { identifyCode: _ctx.identifyCode }, null, 8, ["identifyCode"])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("a", {
                    class: "dlbtn",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
                  }, "登录")
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_30, [
                  _createElementVNode("a", {
                    class: "dlbtnx",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.nlogin && _ctx.nlogin(...args)))
                  }, "匿名登录")
                ], 512), [
                  [_vShow, _ctx.guest=='1']
                ])
              ]),
              _createVNode(_component_TanChuang, {
                content: _ctx.content,
                showno: _ctx.showno
              }, null, 8, ["content", "showno"])
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("span", null, _toDisplayString(_ctx.unitname), 1),
          _hoisted_33,
          _createElementVNode("a", _hoisted_34, _toDisplayString(_ctx.proname), 1),
          _createTextVNode("    " + _toDisplayString(_ctx.versiontype) + "    版本号：" + _toDisplayString(_ctx.version) + "    ", 1),
          _createElementVNode("a", _hoisted_35, _toDisplayString(_ctx.icp), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.zhuangtai.lobg)
        }, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("div", {
                class: "lotitr fr",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closexiazai && _ctx.closexiazai(...args)))
              }, _hoisted_40)
            ]),
            _hoisted_41
          ])
        ], 2)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.errbg)
    }, [
      _createElementVNode("div", _hoisted_43, [
        _hoisted_44,
        _createElementVNode("div", null, _toDisplayString(_ctx.tishi), 1)
      ])
    ], 2)
  ]))
}